import { useEffect, useState } from 'react';

/** Returns `value` after it has stopped changing for `delayMs`. */
export function useDebounceValue<T>(value: T, delayMs: number): T {
	const [debounced, setDebounced] = useState(value);
	useEffect(() => {
		const id = setTimeout(() => setDebounced(value), delayMs);
		return () => clearTimeout(id);
	}, [value, delayMs]);
	return debounced;
}
